import type { EvaluationResult } from "../model/types";

export function createObj(evaluation: EvaluationResult, modelName: string): Blob {
  if (evaluation.bodies.length === 0) throw new Error("There are no valid bodies to export");
  const lines: string[] = [`# ${modelName}`, "# Exported by ModelMotive", "s off"];
  let vertexOffset = 1;
  for (const body of evaluation.bodies) {
    lines.push(`o ${body.name.replace(/\s+/g, "_")}`);
    for (let index = 0; index < body.vertices.length; index += 3) {
      lines.push(`v ${body.vertices[index] ?? 0} ${body.vertices[index + 1] ?? 0} ${body.vertices[index + 2] ?? 0}`);
    }
    for (let index = 0; index < body.normals.length; index += 3) {
      lines.push(`vn ${body.normals[index] ?? 0} ${body.normals[index + 1] ?? 0} ${body.normals[index + 2] ?? 0}`);
    }
    for (let index = 0; index < body.triangles.length; index += 3) {
      const a = (body.triangles[index] ?? 0) + vertexOffset;
      const b = (body.triangles[index + 1] ?? 0) + vertexOffset;
      const c = (body.triangles[index + 2] ?? 0) + vertexOffset;
      lines.push(`f ${a}//${a} ${b}//${b} ${c}//${c}`);
    }
    vertexOffset += body.vertices.length / 3;
  }
  return new Blob([lines.join("\n")], { type: "text/plain" });
}
